/*
 * Zaunfeld-Konfigurator – Shopify-Adapter.
 *
 * Individuelle Felder haben keinen festen Katalogpreis. Zwei Modi:
 *
 * 1. "varianten" (Standard, empfohlen):
 *    Das versteckte Produkt "Individuelles Zaunfeld" hat Preis-Varianten im
 *    Raster (Option "Preis": "50 €", "60 €", … – CSV-Generator:
 *    export/erzeuge-varianten-csv.js). Der Konfigurator rundet den
 *    Kalkulationspreis aufs Raster auf (shopPreis) und legt GENAU 1 Stück
 *    der passenden Variante in den Warenkorb → saubere Anzeige ("Anzahl: 1").
 *    Die Variante wird über den Optionswert gefunden, nicht über den Preis –
 *    so bleibt die Zuordnung auch bei globalen Preisaufschlägen stabil.
 *
 * 2. "menge":
 *    Mengen-Produkt mit kleinem Einheitspreis (z. B. 0,10 €);
 *    Menge = Preis / Einheitspreis. Centgenau, aber der Kunde sieht große
 *    Stückzahlen im Warenkorb. Nur als Fallback.
 *
 * Langgut: Felder über der Langgut-Grenze (ergebnis.langgut) landen im
 * separaten Produkt handleLanggut – das hängt im Shop am Versandprofil
 * "Langgut", damit der Speditions-Langgutzuschlag korrekt berechnet wird.
 *
 * Verwendung:
 *   adapter: FeldShopifyAdapter.erstelle({
 *     handle: 'individuelles-zaunfeld',
 *     handleLanggut: 'individuelles-zaunfeld-langgut',
 *     modus: 'varianten'
 *   })
 */
(function () {
  'use strict';

  function erstelle(optionen) {
    var handle = optionen && optionen.handle;
    var handleLanggut = (optionen && optionen.handleLanggut) || handle;
    var modus = (optionen && optionen.modus) || 'varianten';

    function root() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    function ladeProdukt(zielHandle) {
      return fetch(root() + 'products/' + zielHandle + '.js').then(function (r) {
        if (!r.ok) throw new Error('Das Konfigurator-Produkt "' + zielHandle + '" wurde im Shop nicht gefunden (' + r.status + ').');
        return r.json();
      });
    }

    /* Variante über den Optionswert ("130 €") finden; Fallback: nächsthöherer Rasterwert. */
    function findePreisVariante(produkt, zielEuro) {
      var ziel = Math.round(zielEuro);
      var kandidaten = produkt.variants.map(function (v) {
        var wert = parseInt(String(v.option1 || '').replace(/[^\d]/g, ''), 10);
        return { variante: v, wert: isNaN(wert) ? null : wert };
      }).filter(function (k) { return k.wert != null; });

      var exakt = kandidaten.filter(function (k) { return k.wert === ziel; })[0];
      if (exakt) return exakt.variante;

      var hoehere = kandidaten
        .filter(function (k) { return k.wert > ziel; })
        .sort(function (a, b) { return a.wert - b.wert; })[0];
      return hoehere ? hoehere.variante : null;
    }

    function inDenWarenkorb(variantId, menge, eigenschaften) {
      return fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: menge, properties: eigenschaften }]
        })
      }).then(function (r) {
        if (!r.ok) throw new Error('Der Warenkorb hat nicht geantwortet (' + r.status + ').');
        window.location.href = '/cart';
      });
    }

    return {
      addToCart: function (ergebnis, meta) {
        if (!handle) {
          return Promise.reject(new Error('Kein Produkt-Handle für individuelle Zaunfelder konfiguriert (Section-Einstellungen).'));
        }
        var zielHandle = ergebnis.langgut ? handleLanggut : handle;
        return ladeProdukt(zielHandle).then(function (produkt) {
          if (modus === 'menge') {
            var variante = produkt.variants[0];
            var einheitEuro = variante.price / 100;
            if (!einheitEuro || einheitEuro <= 0) {
              throw new Error('Das Konfigurator-Produkt hat keinen gültigen Einheitspreis.');
            }
            var menge = Math.max(1, Math.round(ergebnis.shopPreis / einheitEuro));
            return inDenWarenkorb(variante.id, menge, meta.eigenschaften);
          }

          var preisVariante = findePreisVariante(produkt, ergebnis.shopPreis);
          if (!preisVariante) {
            throw new Error('Für ' + Math.round(ergebnis.shopPreis) + ' € gibt es noch keine Preis-Variante am Konfigurator-Produkt. ' +
              'Bitte Varianten-Raster erweitern (export/erzeuge-varianten-csv.js).');
          }
          return inDenWarenkorb(preisVariante.id, 1, meta.eigenschaften);
        });
      }
    };
  }

  window.FeldShopifyAdapter = { erstelle: erstelle };
}());
